import React from "react";
import { array, func } from "prop-types";
import { Stack, Box } from "@mui/material";
import DocumentCard from "./DocumentCard";

const DocumentGrid = (props) => {
  const { documents, Header } = props;

  // TODO: Can we remove the Header prop from this component?
  return (
    <Box sx={{ paddingTop: 0 }}>
      {Header && <Header />}
      <Stack
        direction="row"
        sx={{
          flexWrap: "wrap",
          gap: 3,
        }}
      >
        {documents.map((doc, i) => (
          <Box
            key={i}
            sx={{
              flex: {
                xs: "0 0 100%",
                sm: "0 0 calc(50% - 12px)",
                lg: "0 0 calc(33.333% - 16px)",
              },
              display: "flex",
              alignItems: "stretch",
              minWidth: 0,
            }}
          >
            <DocumentCard
              doc={doc}
              docTitle={doc.title}
              docDescription={doc.description}
              docUrl={doc.attachments[0].url}
              platformTags={doc.platform_tags}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

DocumentGrid.defaultProps = {
  documents: [],
};

DocumentGrid.propTypes = {
  documents: array,
  Header: func,
};

export default DocumentGrid;
